<div class="lightbox-table mat-elevation-z2">
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="seriesName" sticky>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="series-name-col-labels">
        {{ element.seriesName }}
        <ng-container *ngIf="compareBy && element.stack">
          - {{ getSystemSchoolNameFromStack(element.stack) }}</ng-container
        >
      </td>
    </ng-container>

    <!-- Time Period Columns -->
    <ng-container *ngFor="let column of columns" [matColumnDef]="column">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="time-period-col-labels"
        mat-sort-header
      >
        {{ column }}
        <custom-mat-table-sort-icon
          [activeColumn]="sort.active"
          [column]="column"
          [sortDirection]="sort.direction"
        ></custom-mat-table-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">
        <span [tooltip]="mzTableTooltip" *ngIf="element[column]">
          <ng-container *ngIf="element[column].y || element[column].y === 0">
            {{ dataPrefix || ""
            }}{{
              element[column].y.toLocaleString(undefined, {
                maximumFractionDigits: roundTo
              })
            }}{{ dataSuffix || "" }}
          </ng-container>
          <ng-template #mzTableTooltip>
            <mz-table-tooltip
              [numerator]="element[column].numerator"
              [descriptor]="descriptor"
              [denominator]="
                dataSuffix === '' ? null : element[column].denominator
              "
            ></mz-table-tooltip>
          </ng-template>
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [length]="dataSource?.data.length > 0"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 25, 50, 100]"
  [showFirstLastButtons]="true"
>
</mat-paginator>
